// 阿仕图project接口
export default function (axios) {
  return {
    // 余额支付
    payForProjectApi(params) {
      return axios.post("/buyGoodsCtl/payForProject", params)
    },
  };
}
